import React, { Component, useState, useEffect } from 'react'

import { makeStyles } from '@material-ui/core/styles'

import { connect } from 'react-redux'
import { selectZoomCourseType, updateZoomCourseEventsIds } from '../../actions/'
import Typography from '@material-ui/core/Typography'
import LinearProgress from '@material-ui/core/LinearProgress'
import Button from '@material-ui/core/Button'

import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import GetAppIcon from '@material-ui/icons/GetApp'
import Box from '@material-ui/core/Box'

import InputAdornment from '@material-ui/core/InputAdornment'
import FormHelperText from '@material-ui/core/FormHelperText'
import FormControl from '@material-ui/core/FormControl'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import BrowserStore from 'store'

import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormLabel from '@material-ui/core/FormLabel'

import { CourseJsonQueue } from './Index'

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`scrollable-force-tabpanel-${index}`}
      aria-labelledby={`scrollable-force-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

function StepOne(props) {
  // const classes = useStyles();

  const { data, onTabChange, onCourseIdChanges } = props

  // console.log('MAIN LOAD',data)

  const userData = BrowserStore.get('inseadCanvasAdmin')

  const [value, setValue] = React.useState(data.isSingleCourse === true ? 0 : 1)

  const [radioValue, setRadioValue] = React.useState('30')

  const handleChange = (event, newValue) => {
    setValue(newValue)

    let type = ''
    type = newValue === 0 ? true : false

    onTabChange(type)
  }

  const handleCourseIdChange = (event) => {
    let courseId = ''
    let courseIds = []

    if (value === 0) {
      courseId = event.target.value
    } else {
      courseIds = event.target.value
    }

    let dataSet = {
      courseId: courseId,
      courseIds: courseIds,
      requestedBy: userData.sub_account.email,
      daysCount: data.daysCount
    }

    onCourseIdChanges(dataSet)
  }

  const handleDaysChange = (event) => {
    let days = event.target.value

    setRadioValue(days)
  }

  useEffect(() => {
    let dataSet = {
      courseId: data.courseId,
      courseIds: data.courseIds,
      requestedBy: userData.sub_account.email,
      daysCount: radioValue
    }

    onCourseIdChanges(dataSet)
  }, [radioValue])

  // useEffect(() => {

  //   console.log('changed ',value)

  // },[value])

  return (
    <Paper square>
      <Tabs
        value={value}
        indicatorColor='primary'
        textColor='primary'
        onChange={handleChange}
        aria-label='disabled tabs example'
      >
        <Tab label='One Time Run' />

        <Tab label='Add to Queue' />
      </Tabs>

      <TabPanel value={value} index={0}>
        <FormControl fullWidth>
          <InputLabel htmlFor='standard-adornment-amount'>Course ID</InputLabel>
          <Input
            id='standard-adornment-amount'
            onChange={handleCourseIdChange}
          />
        </FormControl>

        <p></p>
        <p></p>

        <FormControl component='fieldset'>
          <FormLabel component='legend'>
            {' '}
            Update next {radioValue} days events
          </FormLabel>
          <RadioGroup
            row
            aria-label='days_count'
            name='days_count'
            value={radioValue}
            onChange={handleDaysChange}
          >
            <FormControlLabel
              checked={radioValue === '30'}
              value='30'
              control={<Radio />}
              label='30 DAYS'
            />
            <FormControlLabel
              checked={radioValue === '60'}
              value='60'
              control={<Radio />}
              label='60 DAYS'
            />
            <FormControlLabel
              checked={radioValue === '90'}
              value='90'
              control={<Radio />}
              label='90 DAYS'
            />
          </RadioGroup>
        </FormControl>
      </TabPanel>

      <TabPanel value={value} index={1}>
        <CourseJsonQueue />
      </TabPanel>
    </Paper>
  )
}

function mapStateToProps(state) {
  return {
    data: state.Zoom
  }
}

const mapDispatchToProps = (dispatch) => ({
  onTabChange: (type) => {
    dispatch(selectZoomCourseType(type))
  },

  onCourseIdChanges: (ids) => {
    dispatch(updateZoomCourseEventsIds(ids))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(StepOne)
